import { render } from "./UserBasicInfo.vue?vue&type=template&id=d78158be&scoped=true"
import script from "./UserBasicInfo.vue?vue&type=script&lang=js"
export * from "./UserBasicInfo.vue?vue&type=script&lang=js"

import "./UserBasicInfo.vue?vue&type=style&index=0&id=d78158be&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d78158be"]])

export default __exports__